module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bb-bg-1-sp-eb835bfea7360727707c521474a87ed9.png";